import find from 'lodash/find';

export var update = function update(list) {
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  return function (updated) {
    if (find(list.toJS(), function (e) {
      return e[field] === updated[field];
    }) !== undefined) {
      return list.toJS().map(function (existing) {
        return existing[field] === updated[field] ? updated : existing;
      });
    } else {
      list.push(updated);
      return list;
    }
  };
};

export var remove = function remove(list) {
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  return function (removed) {
    return list.filter(function (existing) {
      return existing[field] !== removed[field];
    });
  };
};